import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SITE, NAV_LINKS } from "@/data/site";

const social = [
  { label: "GitHub", href: SITE.github },
  { label: "LinkedIn", href: SITE.linkedin },
  { label: "Email", href: `mailto:${SITE.email}` },
];

export default function Footer() {
  return (
    <footer
      className="hairline-t bg-ink-base"
      data-testid="footer"
    >
      <div className="mx-auto max-w-7xl px-6 py-16 md:px-12 md:py-20 lg:px-24">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-6">
            <h2 className="font-cabinet text-3xl font-bold tracking-tight text-primary-ink md:text-4xl">
              {SITE.name}
            </h2>
            <p className="mt-3 font-mono text-xs uppercase tracking-[0.18em] text-muted-ink">
              {SITE.role}
            </p>
            <p className="mt-6 max-w-sm leading-relaxed text-secondary-ink">
              Client engagements are delivered through{" "}
              <a
                href={SITE.companyUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary-ink underline decoration-white/20 underline-offset-4 transition-colors hover:decoration-accent"
              >
                {SITE.company}
              </a>
              .
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="overline mb-5">Navigate</p>
            <ul className="space-y-3">
              {NAV_LINKS.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    data-testid={`footer-link-${link.label.toLowerCase()}`}
                    className="text-secondary-ink transition-colors hover:text-primary-ink"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="overline mb-5">Connect</p>
            <ul className="space-y-3">
              {social.map((s) => (
                <li key={s.label}>
                  <a
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`footer-social-${s.label.toLowerCase()}`}
                    className="group inline-flex items-center gap-1.5 text-secondary-ink transition-colors hover:text-primary-ink"
                  >
                    {s.label}
                    <ArrowUpRight className="h-3.5 w-3.5 opacity-0 transition-all group-hover:translate-x-0.5 group-hover:-translate-y-0.5 group-hover:opacity-100" />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="hairline-t mt-16 flex flex-col gap-3 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-mono text-xs text-muted-ink">
            © {new Date().getFullYear()} {SITE.name}. All rights reserved.
          </p>
          <p className="font-mono text-xs text-muted-ink">
            Built &amp; engineered by Vivek Chandra.
          </p>
        </div>
      </div>
    </footer>
  );
}
